import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import { PATH_INVOICES } from './paths';
import {
  InvoiceDryRunDetails,
  InvoiceDryRunList,
  InvoiceDryRunProviderInvoiceDetails,
  InvoiceRunList,
  InvoiceRunInvoicesList,
  ProviderInvoiceDetails,
} from '../pages';

const INVOICES_ROUTES = [
  {
    path: PATH_INVOICES.list,
    roles: ['provider_invoices.view'],
    component: <InvoiceRunList />,
    index: true,
  },
  {
    path: PATH_INVOICES.providerRunInvoicesList,
    roles: ['provider_invoices.view'],
    component: <InvoiceRunInvoicesList />,
    index: false,
  },
  {
    path: PATH_INVOICES.providerInvoiceDetails,
    roles: ['provider_invoices.view'],
    component: <ProviderInvoiceDetails />,
    index: false,
  },
  {
    path: PATH_INVOICES.dryRuns,
    roles: ['provider_invoices.view'],
    component: <InvoiceDryRunList />,
    index: false,
  },
  {
    path: PATH_INVOICES.dryRunDetails,
    roles: ['provider_invoices.view'],
    component: <InvoiceDryRunDetails />,
    index: false,
  },
  {
    path: PATH_INVOICES.dryRunProviderInvoiceDetails,
    roles: ['provider_invoices.view'],
    component: <InvoiceDryRunProviderInvoiceDetails />,
    index: false,
  },
];

export const InvoicesRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {INVOICES_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
